import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'

export interface MentalMinuteSchoolOverviewResponse {
  mental_minute_school_overview: MentalMinuteSchoolOverviewData
}

export interface MentalMinuteSchoolOverviewData {
  aggregate: {
    students: {
      average: number
      total: number
    }
    time_on_task: {
      average: number
      total: number
    }
    sprints_mastered: {
      average: number
      total: number
    }
    correct_answers: {
      average: number
      total: number
    }
    sprints_attempted: {
      average: number
    }
    improvement: {
      average: number
    }
  }
  schools: {
    school_id: number
    number_of_students: number
    sprints_mastered: number
    time_on_task: number
    correct_answers: number
    average_sprints_attempted: number
    average_improvement: number
  }[]
}

export async function mentalMinuteSchoolOverview(
  this: StudentEventsService,
  product: LegacyProductMs,
  scope: StatsScope,
  period: NormalizedInterval,
): Promise<Nullable<MentalMinuteSchoolOverviewData>> {
  if (isEmpty(scope.ids)) return null

  const url = this.buildUrl('mental_minute_school_overview', product, scope)
  const query = this.buildQuery(scope, period)

  const response = await this.fetchData<MentalMinuteSchoolOverviewResponse>(url, query)
  if (!response) return null

  return response.mental_minute_school_overview.schools.length === 0 ? null : response.mental_minute_school_overview
}
